import React, { FC, useEffect, useState } from 'react'

import { useAuth } from 'core/auth'
import { i18nMap as i18nMapConfig } from 'shared/config/lib/language'
import { getToken } from 'shared/config'
import { useLanguageInit, useMount } from 'shared/hooks'
import { apiHttp } from 'shared/request'
import { useWalletListener } from 'wallet'

export const FeatureMain: FC = ({ children }) => {
    const [initialized, setInitialized] = useState<boolean>(false)

    // Internationalized language settings
    useLanguageInit(i18nMapConfig)

    const {
        methods: { initUserInfo }
    } = useAuth()
    // init user form storage
    useMount(initUserInfo)
    // listen wallet account change
    useWalletListener()

    useEffect(() => {
        apiHttp.addRequestInterceptor(p => {
            const token = getToken()
            let headers = p.headers

            if (token) {
                headers = {
                    ...headers,
                    Authorization: `Bearer ${token}`
                }
            }
            return { ...p, headers }
        })
        setInitialized(true)
    }, [])

    if (!initialized) return null

    return <>{children}</>
}
